import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm16-6H1v18h22V3zm-2 16.01H3V4.99h18v14.02z"
}), 'AspectRatioSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AspectRatioSharp.js
// module id = 2136
// module chunks = 2